let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("d5Kn9")).then(() => parcelRequire('aDwWR'));